import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25 0C11.23 0 0 11.23 0 25c0 12.043 9.553 25 25 25 13.77 0 25-11.23 25-25S38.77 0 25 0zm10.925 33.384l-2.54 2.54-8.385-8.4-8.384 8.436-2.54-2.54 8.384-8.385-8.385-8.384 2.49-2.49 8.384 8.386 8.433-8.435 2.49 2.49-8.384 8.436 8.434 8.384z"
  })]
});